import React, { useEffect, useState } from "react";
import "../../profile.css";

import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

import service from "../../services/service";
import endpoints from "../../services/endpoints";
import { formatCmsHtml } from "../../utils/formatCmsHtml";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  const [privacyData, setPrivacyData] = useState(null);
  const [loading, setLoading] = useState(false);

  /* =========================
      GET PRIVACY POLICY
  ========================= */

  const getPrivacyPolicy = async () => {
    try {
      setLoading(true);

      const response = await service.get(
        endpoints.cms.privacyPolicy,
      );

      setPrivacyData(response?.data?.data || null);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPrivacyPolicy();
  }, []);

  return (
    <div className="info-page">
      <div className="info-page-top">
        <ArrowLeft
          className="back-btn"
          onClick={() => navigate("/contact-info")}
        />

        <h2>Privacy Policy</h2>
      </div>

      {loading ? (
        <p className="favourites-loading">
          Loading Privacy Policy...
        </p>
      ) : (
        <div className="info-page-content">
          <div
            className="cms-html-content"
            dangerouslySetInnerHTML={{
              __html: formatCmsHtml(privacyData || ""),
            }}
          />
        </div>
      )}
    </div>
  );
};

export default PrivacyPolicy;